import { omit, orderBy, shuffle } from 'es-toolkit';

import { type AdaptedQuiz } from './quizListDataAdapter';

export const sortQuizChoice = (quizList: AdaptedQuiz[], isShuffle: boolean) => {
  return quizList.map(quiz => {
    if (
      quiz.type !== 'multiple' &&
      quiz.type !== 'match' &&
      quiz.type !== 'order'
    )
      return quiz;
    if (quiz.type === 'order') {
      // ORDER 는 원본 순서가 곧 정답이므로 문제지에 정답 순서를 복원하면 안 된다.
      // 토글 OFF 는 어댑터가 처음 섞어 둔 출력 순서를 그대로 유지한다.
      if (!isShuffle) return quiz;
      return {
        ...quiz,
        orderData: {
          ...quiz.orderData,
          items: shuffle(quiz.orderData.items ?? []),
        },
      };
    }
    if (quiz.type === 'match') {
      return {
        ...quiz,
        matchData: {
          ...quiz.matchData,
          leftItems: isShuffle
            ? shuffle(quiz.matchData.leftItems ?? [])
            : orderBy(quiz.matchData.leftItems, ['order'], ['asc']),
          rightItems: isShuffle
            ? shuffle(quiz.matchData.rightItems ?? [])
            : orderBy(quiz.matchData.rightItems, ['order'], ['asc']),
        },
      };
    }

    const { multipleData } = quiz;

    const { adaptedChoiceList } = multipleData;

    if (!adaptedChoiceList) return quiz;

    //after shuffle answers, we need to map the answers to the choiceListV2
    const sortedChoice = isShuffle
      ? shuffle(adaptedChoiceList)
      : orderBy(adaptedChoiceList, ['order'], ['asc']);

    return {
      ...quiz,
      multipleData: {
        ...quiz.multipleData,
        choiceListV2: sortedChoice.map(choice =>
          omit(choice, ['order', 'isAnswer']),
        ),
        answerList: sortedChoice
          .filter(choice => choice.isAnswer)
          .map(choice => String(sortedChoice.indexOf(choice))),
      },
    };
  });
};
